import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
const SectionCard = ({ title, details }) => {
  const splitEntries = chunkArray(Object.entries(details), 2); // Diviser les paires clé-valeur en groupes de 2

  return (
    <>
      <Card className="mb-4">
        {title == "Audit" || title == "Suivi" ? (
          <CardTitle tag="h5" style={{ paddingLeft: "10px", paddingTop: 10 }}>
            {title}
          </CardTitle>
        ) : (
          <CardTitle tag="h5">{title}</CardTitle>
        )}

        <CardBody>
          {splitEntries.map((pair, rowIndex) => (
            <Row key={rowIndex}>
              {pair.map(([key, value], colIndex) => (
                <Col sm="6" key={colIndex}>
                  <p className="mb-2">
                    <i style={{ color: "#9d9c9c" }}>
                      <span
                        style={{
                          display: "inline-block",
                          width: "55%",
                          whiteSpace: "balance",
                        }}
                      >
                        {key} :
                      </span>
                    </i>
                    <span
                      style={{
                        whiteSpace: "balance",
                        fontFamily: "sans-serif",
                        width: "55%",
                      }}
                    >
                      {renderValue(value)}
                    </span>
                  </p>
                </Col>
              ))}
            </Row>
          ))}
        </CardBody>
      </Card>
    </>
  );
};
const chunkArray = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );
};

const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé" || value === "Fait") {
    return <span className="bg-success badge bg-secondary">{value}</span>;
  } else if (
    value === "En attente" ||
    value === "En attente de validation" ||
    value === "A faire"
  ) {
    return <span className="bg-info badge bg-secondary">{value}</span>;
  } else if (value === "Annulé") {
    return <span className="bg-danger badge bg-secondary">{value}</span>;
  } else if (
    value !== null &&
    value !== undefined &&
    value &&
    value.includes("\n")
  ) {
    return (
      <span style={{ textAlign: "left" }}>
        <br />
        {value.split("\n").map((line, i) => (
          <>
            {line}
            {i < value.split("\n").length - 1 && <br />}
          </>
        ))}
      </span>
    );
  } else {
    return (
      <span style={{ textAlign: "left" }}>
        <br />
        {value}
      </span>
    );
  }
};
export default SectionCard;
